import { useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";
import SubscribeForm from "./SubscribeForm";
import { FORM } from "@/constants/testIds";
import { useSiteContent } from "@/hooks/useSiteContent";

export default function MagnetModal({ open, magnetKey, onClose }) {
  const { content } = useSiteContent();
  const MAGNETS = content.magnets;
  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
      return () => { document.body.style.overflow = ""; };
    }
  }, [open]);

  const magnet = MAGNETS.find((m) => m.key === magnetKey);

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.25 }}
          className="fixed inset-0 z-50 flex items-center justify-center p-4 md:p-8 bg-[#1A2825]/40 backdrop-blur-sm"
          onClick={onClose}
        >
          <motion.div
            initial={{ opacity: 0, scale: 0.95, y: 16 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.95, y: 16 }}
            transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
            className="relative w-full max-w-lg bg-white rounded-[2rem] border border-[#EAE5D9] shadow-[0_30px_80px_-30px_rgba(28,107,97,0.45)] p-8 md:p-10 max-h-[90vh] overflow-y-auto"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              type="button"
              data-testid={FORM.modalClose}
              onClick={onClose}
              className="absolute top-4 right-4 h-9 w-9 rounded-full bg-[#F6F3EB] hover:bg-[#EAE5D9] flex items-center justify-center text-[#1A2825]"
              aria-label="Bezár"
            >
              <X className="h-4 w-4" />
            </button>

            {magnet && (
              <div className="mb-6">
                <div
                  className="inline-block text-[10px] uppercase tracking-[0.28em] px-3 py-1 rounded-full border"
                  style={{ color: magnet.accent, borderColor: `${magnet.accent}40` }}
                >
                  {magnet.badge}
                </div>
                <h3 className="font-serif-display text-2xl md:text-3xl text-[#1A2825] mt-3 leading-tight">
                  {magnet.title}
                </h3>
                <p className="mt-2 text-sm text-[#3A4D4A] font-light leading-relaxed">
                  {magnet.subtitle}
                </p>
              </div>
            )}

            <SubscribeForm
              key={magnetKey || "general"}
              magnet={magnetKey || "general"}
              magnetLabel={magnet?.title}
              compact
            />
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
